import { Injectable } from '@angular/core';

export interface CanComponentDeactivate {
    canDeactivate: () => Promise<boolean> | boolean;
}

// Checks a component to see if it has a CanDeactive function, and stops route change until it returns true
@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard {
    canDeactivate(component: CanComponentDeactivate) {
        if (component) {
            return component.canDeactivate ? component.canDeactivate() : true;
        }
        return true;
    }
}
